import React, { useEffect, useState } from 'react';
import LoadingBar from 'react-top-loading-bar';
import { useTransition, animated } from 'react-spring';
import { FaArrowCircleUp, FaAngleDoubleLeft, FaAngleDoubleRight, FaEye } from 'react-icons/fa';
import NavbarDetailBlog from '../../../components/navbarDetailBlog.tsx';
import HeaderDetailBlog from '../utils/headerDetailBlog.tsx';
import Footer from '../../../components/footer.tsx';
import { Link } from 'react-router-dom';
import ImageModal from '../utils/imageModal.tsx';


import usePreventZoom from '../../../preventZoom.js';

import Header from '../../../assets/Blog/ACL/ACL_PART8/Detail/HEADER_DETAIL_ACL_PART8.webp';
import Pict1 from "../../../assets/Blog/ACL/ACL_PART8/Detail/1.webp";
import Pict2 from "../../../assets/Blog/ACL/ACL_PART8/Detail/2.webp";
import Pict3 from "../../../assets/Blog/ACL/ACL_PART8/Detail/3.webp";
import Pict4 from "../../../assets/Blog/ACL/ACL_PART8/Detail/4.webp";
import Pict5 from "../../../assets/Blog/ACL/ACL_PART8/Detail/5.webp";
import Pict6 from "../../../assets/Blog/ACL/ACL_PART8/Detail/6.webp";
import Pict7 from "../../../assets/Blog/ACL/ACL_PART8/Detail/7.webp";
import Pict8 from "../../../assets/Blog/ACL/ACL_PART8/Detail/8.webp";
import Pict9 from "../../../assets/Blog/ACL/ACL_PART8/Detail/9.webp";
import Pict10 from "../../../assets/Blog/ACL/ACL_PART8/Detail/10.webp";

import Gallery1 from "../../../assets/Blog/ACL/ACL_PART8/Detail/11.webp";
import Gallery2 from "../../../assets/Blog/ACL/ACL_PART8/Detail/12.webp";
import Gallery3 from "../../../assets/Blog/ACL/ACL_PART8/Detail/13.webp";
import Gallery4 from "../../../assets/Blog/ACL/ACL_PART8/Detail/14.webp";
import Gallery5 from "../../../assets/Blog/ACL/ACL_PART8/Detail/15.webp";
import Gallery6 from "../../../assets/Blog/ACL/ACL_PART8/Detail/16.webp";
import Gallery7 from "../../../assets/Blog/ACL/ACL_PART8/Detail/17.webp";
import Gallery8 from "../../../assets/Blog/ACL/ACL_PART8/Detail/18.webp";
import Gallery9 from "../../../assets/Blog/ACL/ACL_PART8/Detail/19.webp";
import Gallery10 from "../../../assets/Blog/ACL/ACL_PART8/Detail/20.webp";
import Gallery11 from "../../../assets/Blog/ACL/ACL_PART8/Detail/21.webp";
import Gallery12 from "../../../assets/Blog/ACL/ACL_PART8/Detail/22.webp";
import Gallery13 from "../../../assets/Blog/ACL/ACL_PART8/Detail/23.webp";
import Gallery14 from "../../../assets/Blog/ACL/ACL_PART8/Detail/24.webp";
import Gallery15 from "../../../assets/Blog/ACL/ACL_PART8/Detail/25.webp";
import Gallery16 from "../../../assets/Blog/ACL/ACL_PART8/Detail/26.webp";
import Gallery17 from "../../../assets/Blog/ACL/ACL_PART8/Detail/27.webp";
import Gallery18 from "../../../assets/Blog/ACL/ACL_PART8/Detail/28.webp";
import Gallery19 from "../../../assets/Blog/ACL/ACL_PART8/Detail/29.webp";
import Gallery20 from "../../../assets/Blog/ACL/ACL_PART8/Detail/30.webp";
import Gallery21 from "../../../assets/Blog/ACL/ACL_PART8/Detail/31.webp";
import Gallery22 from "../../../assets/Blog/ACL/ACL_PART8/Detail/32.webp";
import Gallery23 from "../../../assets/Blog/ACL/ACL_PART8/Detail/33.webp";
import Gallery24 from "../../../assets/Blog/ACL/ACL_PART8/Detail/34.webp";
import Gallery25 from "../../../assets/Blog/ACL/ACL_PART8/Detail/35.webp";
import Gallery26 from "../../../assets/Blog/ACL/ACL_PART8/Detail/36.webp";
import Gallery27 from "../../../assets/Blog/ACL/ACL_PART8/Detail/37.webp";
import Gallery28 from "../../../assets/Blog/ACL/ACL_PART8/Detail/38.webp";
import Gallery29 from "../../../assets/Blog/ACL/ACL_PART8/Detail/39.webp";
import Gallery30 from "../../../assets/Blog/ACL/ACL_PART8/Detail/40.webp";
import Gallery31 from "../../../assets/Blog/ACL/ACL_PART8/Detail/41.webp";
import Gallery32 from "../../../assets/Blog/ACL/ACL_PART8/Detail/42.webp";
import Gallery33 from "../../../assets/Blog/ACL/ACL_PART8/Detail/43.webp";
import Gallery34 from "../../../assets/Blog/ACL/ACL_PART8/Detail/44.webp";
import Gallery35 from "../../../assets/Blog/ACL/ACL_PART8/Detail/45.webp";
import Gallery36 from "../../../assets/Blog/ACL/ACL_PART8/Detail/46.webp";
import Gallery37 from "../../../assets/Blog/ACL/ACL_PART8/Detail/47.webp";
import Gallery38 from "../../../assets/Blog/ACL/ACL_PART8/Detail/48.webp";
import Gallery39 from "../../../assets/Blog/ACL/ACL_PART8/Detail/49.webp";
import Gallery40 from "../../../assets/Blog/ACL/ACL_PART8/Detail/50.webp";
import Gallery41 from "../../../assets/Blog/ACL/ACL_PART8/Detail/51.webp";
import Gallery42 from "../../../assets/Blog/ACL/ACL_PART8/Detail/52.webp";
import Gallery43 from "../../../assets/Blog/ACL/ACL_PART8/Detail/53.webp";
import Gallery44 from "../../../assets/Blog/ACL/ACL_PART8/Detail/54.webp";
import Gallery45 from "../../../assets/Blog/ACL/ACL_PART8/Detail/55.webp";
import Gallery46 from "../../../assets/Blog/ACL/ACL_PART8/Detail/56.webp";
import Gallery47 from "../../../assets/Blog/ACL/ACL_PART8/Detail/57.webp";
import Gallery48 from "../../../assets/Blog/ACL/ACL_PART8/Detail/58.webp";
import Gallery49 from "../../../assets/Blog/ACL/ACL_PART8/Detail/59.webp";
import Gallery50 from "../../../assets/Blog/ACL/ACL_PART8/Detail/60.webp";
import Gallery51 from "../../../assets/Blog/ACL/ACL_PART8/Detail/61.webp";
import Gallery52 from "../../../assets/Blog/ACL/ACL_PART8/Detail/62.webp";
import Gallery53 from "../../../assets/Blog/ACL/ACL_PART8/Detail/63.webp";
import Gallery54 from "../../../assets/Blog/ACL/ACL_PART8/Detail/64.webp";
import Gallery55 from "../../../assets/Blog/ACL/ACL_PART8/Detail/65.webp";
import Gallery56 from "../../../assets/Blog/ACL/ACL_PART8/Detail/66.webp";
import Gallery57 from "../../../assets/Blog/ACL/ACL_PART8/Detail/67.webp";
import Gallery58 from "../../../assets/Blog/ACL/ACL_PART8/Detail/68.webp";
import Gallery59 from "../../../assets/Blog/ACL/ACL_PART8/Detail/69.webp";
import Gallery60 from "../../../assets/Blog/ACL/ACL_PART8/Detail/70.webp";
import Gallery61 from "../../../assets/Blog/ACL/ACL_PART8/Detail/71.webp";
import Gallery62 from "../../../assets/Blog/ACL/ACL_PART8/Detail/72.webp";
import Gallery63 from "../../../assets/Blog/ACL/ACL_PART8/Detail/73.webp";
import Gallery64 from "../../../assets/Blog/ACL/ACL_PART8/Detail/74.webp";
import Gallery65 from "../../../assets/Blog/ACL/ACL_PART8/Detail/75.webp";
import Gallery66 from "../../../assets/Blog/ACL/ACL_PART8/Detail/76.webp";
import Gallery67 from "../../../assets/Blog/ACL/ACL_PART8/Detail/77.webp";
import Gallery68 from "../../../assets/Blog/ACL/ACL_PART8/Detail/78.webp";
import Gallery69 from "../../../assets/Blog/ACL/ACL_PART8/Detail/79.webp";
import Gallery70 from "../../../assets/Blog/ACL/ACL_PART8/Detail/80.webp";
import Gallery71 from "../../../assets/Blog/ACL/ACL_PART8/Detail/81.webp";
import Gallery72 from "../../../assets/Blog/ACL/ACL_PART8/Detail/82.webp";
import Gallery73 from "../../../assets/Blog/ACL/ACL_PART8/Detail/83.webp";
import Gallery74 from "../../../assets/Blog/ACL/ACL_PART8/Detail/84.webp";
import Gallery75 from "../../../assets/Blog/ACL/ACL_PART8/Detail/85.webp";
import Gallery76 from "../../../assets/Blog/ACL/ACL_PART8/Detail/86.webp";
import Gallery77 from "../../../assets/Blog/ACL/ACL_PART8/Detail/87.webp";
import Gallery78 from "../../../assets/Blog/ACL/ACL_PART8/Detail/88.webp";
import Gallery79 from "../../../assets/Blog/ACL/ACL_PART8/Detail/89.webp";
import Gallery80 from "../../../assets/Blog/ACL/ACL_PART8/Detail/90.webp";
import Gallery81 from "../../../assets/Blog/ACL/ACL_PART8/Detail/91.webp";
import Gallery82 from "../../../assets/Blog/ACL/ACL_PART8/Detail/92.webp";
import Gallery83 from "../../../assets/Blog/ACL/ACL_PART8/Detail/93.webp";
import Gallery84 from "../../../assets/Blog/ACL/ACL_PART8/Detail/94.webp";
import Gallery85 from "../../../assets/Blog/ACL/ACL_PART8/Detail/95.webp";
import Gallery86 from "../../../assets/Blog/ACL/ACL_PART8/Detail/96.webp";
import Gallery87 from "../../../assets/Blog/ACL/ACL_PART8/Detail/97.webp";
import Gallery88 from "../../../assets/Blog/ACL/ACL_PART8/Detail/98.webp";
import Gallery89 from "../../../assets/Blog/ACL/ACL_PART8/Detail/99.webp";
import Gallery90 from "../../../assets/Blog/ACL/ACL_PART8/Detail/100.webp";


import CommentListExample from '../../../components/comments/commentListExample.tsx';

const ACLPART8: React.FC = () => {
    const [isMd, setIsMd] = useState(window.matchMedia('(min-width: 900px)').matches);
    const [showScrollToTop, setShowScrollToTop] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [selectedAlt, setSelectedAlt] = useState('');
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        setProgress(30);
        setTimeout(() => {
            setProgress(100);
        }, 600);
    }, []);
  
    const openModal = (imageUrl, imageAlt) => {
        setSelectedImage(imageUrl);
        setSelectedAlt(imageAlt);
        setModalVisible(true);
    };
  
    const closeModal = () => {
        setSelectedImage('');
        setSelectedAlt('');
        setModalVisible(false);
    };


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 900px)');
        const updateIsMd = () => {
            setIsMd(mediaQuery.matches);
        };

        mediaQuery.addListener(updateIsMd);
        return () => {
            mediaQuery.removeListener(updateIsMd);
        };
    }, []);

    const handleScroll = () => {
        if (window.scrollY > 350) {
            setShowScrollToTop(true);
        } else {
            setShowScrollToTop(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const arrowTransition = useTransition(showScrollToTop, {
        from: { opacity: 0, transform: 'translateY(100%)' },
        enter: { opacity: 1, transform: 'translateY(0%)' },
        leave: { opacity: 0, transform: 'translateY(100%)' },
        config: { tension: 300, friction: 20 },
      });

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, {passive: false});
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    usePreventZoom();

    return(
        <div className='App'>
            <NavbarDetailBlog/>
            <div className='pt-20 min-w-screen font-condensed text-textGrey'>
                {/* Loading Bar */}
                <LoadingBar color="#8C001f" progress={progress} onLoaderFinished={() => setProgress(0)} />
                <section className='hidden w-64 mr-10 group transform hover:translate-y-[-5px] transition-transform duration-300 ease-in-out'>
                        <script type='text/javascript' id='mapmyvisitors' src='https://mapmyvisitors.com/map.js?cl=e1e1e1&w=300&t=n&d=fngBtcVXvPP4eW7t-ugYnO9uc3XJHrNYu7CAB7PGnao&co=ffffff&cmo=8c001f&cmn=d4201e&ct=ffffff'></script>
                </section>
                <HeaderDetailBlog backgroundImage={Header} title="Stopping by and roaming around Switzerland (Part 8)" date="2" year="August, 2025" backgroundPosition="center center"></HeaderDetailBlog>
                <div className='author-article text-end pr-4 pt-8 pb-4 text-xs'>
                    <p className='font-condensed text-textGrey'>by Mohammad Rifqi Farhansyah | Association for Computational Linguistics 2025</p>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-36 mb-20'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict1, 'A photo of me arriving at the airport by bus.')}>
                            <img
                                src={Pict1}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="A photo of me arriving at the airport by bus."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>A photo of me arriving at the airport by bus.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Vienna, Austria</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-2xl'>One of the transit countries on my way home was Switzerland, a country I have dreamed of visiting for a long time.</p>
                        <br/>
                        <p className='text-lg'>
                            In the early morning, around 01:00 local time on August 2, 2025, it was finally time for us to head home. The four of us were going to different destinations. I was heading to Zurich, Switzerland. Mussa was going to Venice, Italy. Kak Lucky was flying to Munich, Germany. Kak Iwan was going to Amsterdam, the Netherlands. Since my flight was quite early, and Mussa also had an early bus, we left together in the middle of the night.
                        </p>
                        <br/>
                        <p className='text-lg'>
                            We took the subway, but our stops were different. I got off earlier than Mussa, and we said our goodbyes. I also thanked Mussa for lending me his food container. Around 1:30 a.m., I walked alone to a bus stop where I would be picked up by the airport bus at around 2:30. So I waited there for about an hour. When the bus arrived, it was already quite crowded. Eventually, we reached Vienna International Airport. I went straight inside to look for the baggage drop and check-in counter.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-36 mb-20'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict2, 'My broken suitcase, fixed using German technology.')}>
                            <img
                                src={Pict2}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="My broken suitcase, fixed using German technology."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>My broken suitcase, fixed using German technology.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Vienna International Airport, Austria</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            Before leaving Vienna, I bought some gray duct tape that claimed to have super strong adhesive power. I used it to patch up the broken part of my suitcase, hoping it would survive the journey back to Indonesia. I then asked an elderly woman working there if my baggage could be checked through directly to Indonesia, so I would not need to pick it up during transit. She said it was possible. I was then directed to the counter to print my baggage tag and check in. My flight was still about one to two hours away, so I had some time to walk around Vienna International Airport.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-36 mb-20'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict3, 'A photo of my return ticket with two transit countries.')}>
                            <img
                                src={Pict3}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="A photo of my return ticket with two transit countries."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>A photo of my return ticket with two transit countries.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Vienna International Airport, Austria</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            While walking around, I enjoyed the cool morning air of Vienna. I looked around, observing people in the airport, and maybe hoping to run into another Indonesian. During my time in Austria and Germany, I had surprisingly met many Indonesians. The pattern was always similar. I would see someone who looked very Indonesian, then their partner, who looked clearly German or Austrian, would approach them. After that, they would start speaking Indonesian with their partner or children. Maybe they were Indonesians who married locals and settled there. 
                        </p>
                        <br/>
                        <p className='text-lg'>
                            In Slovakia, it was a bit different. I often saw people doing manual labor, construction workers, food delivery riders, and others, who looked very Indonesian. I did not dare to confirm it, but our eyes met a few times, and it felt like we both knew, silently, that we were Indonesians.
                        </p>
                    </div>
                </div>
                <div className='article-break-1 flex justify-center items-center flex-col md:mb-36 mb-20'>
                    <hr className='w-5/6 mt-4 md:mb-12 mb-4  border-t border-b border-solid'/>
                    <p className='md:text-5xl text-2xl font-bold text-black md:px-44 px-10'>
                        "
                        And so, the journey home began :(
                        "
                    </p>
                    <hr className='w-5/6 mb-4 md:mt-12 mt-4 border-t border-b border-solid'/>
                </div>
                <div className='bg-fixed bg-center w-full h-96 md:mb-36 mb-20' style={{ backgroundImage: `url(${Header})`, backgroundSize: 'cover',}}>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-36 mb-20'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict4, 'A photo upon arriving at Zurich Airport.')}>
                            <img
                                src={Pict4}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="A photo upon arriving at Zurich Airport."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>A photo upon arriving at Zurich Airport.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Zurich Airport, Switzerland</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            From Vienna, I flew with Austrian Airlines and had my first transit in Zurich, Switzerland. We arrived in Switzerland in the morning, around 08:00. My next flight was not until 18:00, so I had plenty of time to explore Zurich a bit. After landing, I did not immediately leave the airport. Before coming to Switzerland, I had watched several videos about Zurich, including what Zurich Airport looks like. So I walked around the airport first and visited The Circle, the iconic area there.
                        </p>
                        <br/>
                        <p className='text-lg'>
                            After that, I planned to buy a train ticket to the city center, specifically Zurich HB, located along Bahnhofstrasse. At first, I was confused because my debit card payment kept getting rejected, even though it was a Mastercard. I asked the customer service staff, but they could not really help either. I almost gave up, thinking this might mean I would fail to explore Zurich. Then suddenly, I thought about using an ATM. Maybe I could withdraw cash first and buy the ticket that way. And it worked. Unfortunately, the minimum withdrawal amount was 50 CHF, while the ticket only cost around 20 CHF. So now I had 30 CHF in cash with no clear plan on how to spend it.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-16 mb-8'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict5, 'A photo at Zurich HB, taken by a stranger, LOL.')}>
                            <img
                                src={Pict5}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="A photo at Zurich HB, taken by a stranger, LOL."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>A photo at Zurich HB, taken by a stranger, LOL.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Zurich HB, Switzerland</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            After buying the ticket, I went straight to Zurich HB, the main station right in the center of Zurich. The train system here relies heavily on honesty, similar to Vienna. You can technically ride the train without scanning a ticket, but if you get caught without a valid ticket, the fine can be almost ten times the original ticket price. Even though I never once encountered ticket inspectors during my rides, I still bought a ticket out of respect for the system and the people working in public transportation. At Zurich HB, there were several iconic things, like blue hanging figures on the ceiling and a large clock in the middle of the station. I asked a stranger who seemed to be a Korean tourist to help take my photo. After that, I walked out of Zurich HB and was immediately greeted by Bahnhofstrasse.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-16 mb-8'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict6, 'Walking around Bahnhofstrasse.')}>
                            <img
                                src={Pict6}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="Walking around Bahnhofstrasse."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>Walking around Bahnhofstrasse.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Bahnhofstrasse, Switzerland</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            Bahnhofstrasse was quite busy, with pedestrian lanes on both sides of the road. It reminded me of “pecinan” areas in Indonesia. The difference was that the shops here were luxury brands like Rolex, Gucci, and others. Each store had a guard, and it seemed like they only invited people who looked wealthy enough. No one invited me in at all, LOL. I thought to myself, yeah, maybe I really do not belong there. With light rain falling, I kept walking, taking out my tripod and trying to take as many good photos as possible. Since I was traveling alone, I had to rely on my tripod. But occasionally, I also asked strangers to help take my pictures.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-16 mb-8'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict7, 'A photo of me eating my packed Indomie.')}>
                            <img
                                src={Pict7}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="A photo of me eating my packed Indomie."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>A photo of me eating my packed Indomie.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Zurich, Switzerland</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            I actually had another destination after Bahnhofstrasse, but it was quite far. Combined with the rain and my legs starting to feel tired, I decided to rest at a small park nearby. I took out the food container I had prepared earlier in Vienna. Inside was just Indomie goreng with instant chicken topping. I knew everything in Switzerland was expensive, so bringing food was definitely the right decision. Plus, I would get food on the plane later anyway.
                        </p>
                        <br/>
                        <p className='text-lg'>
                            To give some context on how expensive Switzerland is, the cost of using the restroom was almost three times more expensive than the cost of my entire meal. But somehow, eating Indomie in Switzerland felt more delicious than anywhere else I had eaten it before. Cold weather, a thick jacket, light rain, spicy Indomie, Denny Caknan’s music playing (LDR), and the beautiful view of Switzerland. It was a perfect lunch combination.
                        </p>
                    </div>
                </div>
                <div className='article-break-1 flex justify-center items-center flex-col md:mb-36 mb-20'>
                    <hr className='w-5/6 mt-4 md:mb-12 mb-4  border-t border-b border-solid'/>
                    <p className='md:text-5xl text-2xl font-bold text-black md:px-44 px-10'>
                        "
                        What dessert fits after lunch?
                        "
                    </p>
                    <hr className='w-5/6 mb-4 md:mt-12 mt-4 border-t border-b border-solid'/>
                </div>
                <div className='bg-fixed bg-center w-full h-96 md:mb-36 mb-20' style={{ backgroundImage: `url(${Pict4})`, backgroundSize: 'cover',}}>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-16 mb-8'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict8, 'A photo near Zurich Lake.')}>
                            <img
                                src={Pict8}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="A photo near Zurich Lake."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>A photo near Zurich Lake.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Zurich Lake, Switzerland</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            After lunch, I felt that the perfect dessert was a walk around Zurich Lake. The water had a greenish color that felt very characteristic of Switzerland, similar to the Aare River. In the middle of the lake, there were swans swimming, while on the other side, several boats were docked. I was not sure if they were fishing boats or just for tourism, because they were simply resting by the lake at that time.
                        </p>
                        <br/>
                        <p className='text-lg'>
                            Zurich Lake is quite large, so I had to take a slightly longer route to reach my next destination. Along the way, I even passed the National Library of Zurich.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-16 mb-8'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict9, 'A photo in front of ETH Zurich.')}>
                            <img
                                src={Pict9}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="A photo in front of ETH Zurich."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>A photo in front of ETH Zurich.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | ETH Zurich, Switzerland</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            Finally, I arrived at my last destination in Zurich, ETH Zurich. ETH Zurich can be considered the Swiss version of ITB. This is where a famous physicist, Albert Einstein, once studied. The campus grounds were very clean, the buildings looked well maintained, and there was a Swiss flag standing proudly in the middle.
                        </p>
                        <br/>
                        <p className='text-lg'>
                            I tried entering the main building. The entrance was a thick wooden door, but with an automatic system. Inside, there was an artist setting up an art installation. I kept walking and exited from the other side of the building. From there, I could see the entire city of Zurich. The campus is located slightly higher than the city center, so the view was stunning. Fog, slightly wet buildings, reflections of light on puddles, green trees and leaves. Everything came together beautifully. At that moment, I truly prayed that one day I could return here, whether to study, work, or even live.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-16 mb-8'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict10, 'A photo at Zurich Airport.')}>
                            <img
                                src={Pict10}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="A photo at Zurich Airport."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>A photo at Zurich Airport.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Zurich Airport, Switzerland</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            After that, I walked back along the same path I had taken earlier. This time, I looked for some souvenirs for my family back home. I only bought chocolate, which I planned to share with close friends and family. In the end, the remaining 30 CHF from my ticket purchase was all spent on chocolate souvenirs. One of my friends from ITB had asked me to buy a hat with “Switzerland” written on it. But when I told him the price was around IDR 400,000 to 600,000, he immediately canceled his request. Honestly, I agreed. It was too expensive for the quality, and it was not even from a luxury brand. After finishing my souvenir shopping, I took the train back to Zurich Airport, checked in, and waited for my next flight to the next transit country. My flight was scheduled at 18:00, but at that time, the sun was still bright, almost like 1 p.m. in Indonesia. Because of that, I felt really satisfied exploring Zurich earlier. The day felt longer and more complete.
                        </p>
                        <div className='article-break-1 flex justify-start items-center flex-col'>
                            <hr className='w-full mt-4 mb-4  border-t border-b border-solid'/>
                        </div>
                        <p className='text-lg font-bold'><i>to be continued...</i></p>
                    </div>
                </div>
                <div className='article-break-1 flex justify-center items-center flex-col md:mb-8 mb-4'>
                    <hr className='w-5/6 mt-4 md:mb-12 mb-4  border-t border-b border-solid'/>
                    <p className='md:text-5xl text-2xl font-bold text-black md:px-44 px-10'>
                        "
                        See you another time, Switzerland. Hope to see you soon!
                        "
                    </p>
                    <hr className='w-5/6 mb-4 md:mt-12 mt-4 border-t border-b border-solid'/>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery1, "Photo Recap: Roaming around Switzerland (Part 1).")}>
                        <img
                            src={Gallery1}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 1)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 1).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery2, "Photo Recap: Roaming around Switzerland (Part 2).")}>
                        <img
                            src={Gallery2}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 2)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 2).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery3, "Photo Recap: Roaming around Switzerland (Part 3).")}>
                        <img
                            src={Gallery3}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 3)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 3).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery4, "Photo Recap: Roaming around Switzerland (Part 4).")}>
                        <img
                            src={Gallery4}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 4)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 4).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery5, "Photo Recap: Roaming around Switzerland (Part 5).")}>
                        <img
                            src={Gallery5}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 5)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 5).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery6, "Photo Recap: Roaming around Switzerland (Part 6).")}>
                        <img
                            src={Gallery6}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 6)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 6).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery7, "Photo Recap: Roaming around Switzerland (Part 7).")}>
                        <img
                            src={Gallery7}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 7)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 7).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery8, "Photo Recap: Roaming around Switzerland (Part 8).")}>
                        <img
                            src={Gallery8}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 8)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 8).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery9, "Photo Recap: Roaming around Switzerland (Part 9).")}>
                        <img
                            src={Gallery9}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 9)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 9).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery10, "Photo Recap: Roaming around Switzerland (Part 10).")}>
                        <img
                            src={Gallery10}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 10)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 10).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery11, "Photo Recap: Roaming around Switzerland (Part 11).")}>
                        <img
                            src={Gallery11}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 11)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 11).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery12, "Photo Recap: Roaming around Switzerland (Part 12).")}>
                        <img
                            src={Gallery12}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 12)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 12).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery13, "Photo Recap: Roaming around Switzerland (Part 13).")}>
                        <img
                            src={Gallery13}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 13)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 13).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery14, "Photo Recap: Roaming around Switzerland (Part 14).")}>
                        <img
                            src={Gallery14}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 14)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 14).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery15, "Photo Recap: Roaming around Switzerland (Part 15).")}>
                        <img
                            src={Gallery15}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 15)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 15).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery16, "Photo Recap: Roaming around Switzerland (Part 16).")}>
                        <img
                            src={Gallery16}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 16)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 16).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery17, "Photo Recap: Roaming around Switzerland (Part 17).")}>
                        <img
                            src={Gallery17}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 17)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 17).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery18, "Photo Recap: Roaming around Switzerland (Part 18).")}>
                        <img
                            src={Gallery18}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 18)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 18).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery19, "Photo Recap: Roaming around Switzerland (Part 19).")}>
                        <img
                            src={Gallery19}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 19)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 19).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery20, "Photo Recap: Roaming around Switzerland (Part 20).")}>
                        <img
                            src={Gallery20}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 20)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 20).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery21, "Photo Recap: Roaming around Switzerland (Part 21).")}>
                        <img
                            src={Gallery21}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 21)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 21).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery22, "Photo Recap: Roaming around Switzerland (Part 22).")}>
                        <img
                            src={Gallery22}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 22)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 22).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery23, "Photo Recap: Roaming around Switzerland (Part 23).")}>
                        <img
                            src={Gallery23}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 23)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 23).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery24, "Photo Recap: Roaming around Switzerland (Part 24).")}>
                        <img
                            src={Gallery24}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 24)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 24).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery25, "Photo Recap: Roaming around Switzerland (Part 25).")}>
                        <img
                            src={Gallery25}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 25)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 25).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery26, "Photo Recap: Roaming around Switzerland (Part 26).")}>
                        <img
                            src={Gallery26}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 26)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 26).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery27, "Photo Recap: Roaming around Switzerland (Part 27).")}>
                        <img
                            src={Gallery27}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 27)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 27).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery28, "Photo Recap: Roaming around Switzerland (Part 28).")}>
                        <img
                            src={Gallery28}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 28)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 28).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery29, "Photo Recap: Roaming around Switzerland (Part 29).")}>
                        <img
                            src={Gallery29}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 29)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 29).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery30, "Photo Recap: Roaming around Switzerland (Part 30).")}>
                        <img
                            src={Gallery30}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 30)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 30).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery31, "Photo Recap: Roaming around Switzerland (Part 31).")}>
                        <img
                            src={Gallery31}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 31)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 31).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery32, "Photo Recap: Roaming around Switzerland (Part 32).")}>
                        <img
                            src={Gallery32}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 32)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 32).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery33, "Photo Recap: Roaming around Switzerland (Part 33).")}>
                        <img
                            src={Gallery33}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 33)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 33).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery34, "Photo Recap: Roaming around Switzerland (Part 34).")}>
                        <img
                            src={Gallery34}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 34)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 34).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery35, "Photo Recap: Roaming around Switzerland (Part 35).")}>
                        <img
                            src={Gallery35}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 35)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 35).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery36, "Photo Recap: Roaming around Switzerland (Part 36).")}>
                        <img
                            src={Gallery36}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 36)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 36).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery37, "Photo Recap: Roaming around Switzerland (Part 37).")}>
                        <img
                            src={Gallery37}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 37)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 37).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery38, "Photo Recap: Roaming around Switzerland (Part 38).")}>
                        <img
                            src={Gallery38}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 38)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 38).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery39, "Photo Recap: Roaming around Switzerland (Part 39).")}>
                        <img
                            src={Gallery39}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 39)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 39).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery40, "Photo Recap: Roaming around Switzerland (Part 40).")}>
                        <img
                            src={Gallery40}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 40)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 40).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery41, "Photo Recap: Roaming around Switzerland (Part 41).")}>
                        <img
                            src={Gallery41}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 41)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 41).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery42, "Photo Recap: Roaming around Switzerland (Part 42).")}>
                        <img
                            src={Gallery42}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 42)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 42).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery43, "Photo Recap: Roaming around Switzerland (Part 43).")}>
                        <img
                            src={Gallery43}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 43)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 43).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery44, "Photo Recap: Roaming around Switzerland (Part 44).")}>
                        <img
                            src={Gallery44}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 44)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 44).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery45, "Photo Recap: Roaming around Switzerland (Part 45).")}>
                        <img
                            src={Gallery45}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 45)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 45).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery46, "Photo Recap: Roaming around Switzerland (Part 46).")}>
                        <img
                            src={Gallery46}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 46)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 46).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery47, "Photo Recap: Roaming around Switzerland (Part 47).")}>
                        <img
                            src={Gallery47}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 47)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 47).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery48, "Photo Recap: Roaming around Switzerland (Part 48).")}>
                        <img
                            src={Gallery48}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 48)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 48).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery49, "Photo Recap: Roaming around Switzerland (Part 49).")}>
                        <img
                            src={Gallery49}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 49)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 49).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery50, "Photo Recap: Roaming around Switzerland (Part 50).")}>
                        <img
                            src={Gallery50}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 50)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 50).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery51, "Photo Recap: Roaming around Switzerland (Part 51).")}>
                        <img
                            src={Gallery51}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 51)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 51).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery52, "Photo Recap: Roaming around Switzerland (Part 52).")}>
                        <img
                            src={Gallery52}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 52)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 52).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery53, "Photo Recap: Roaming around Switzerland (Part 53).")}>
                        <img
                            src={Gallery53}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 53)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 53).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery54, "Photo Recap: Roaming around Switzerland (Part 54).")}>
                        <img
                            src={Gallery54}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 54)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 54).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery55, "Photo Recap: Roaming around Switzerland (Part 55).")}>
                        <img
                            src={Gallery55}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 55)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 55).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery56, "Photo Recap: Roaming around Switzerland (Part 56).")}>
                        <img
                            src={Gallery56}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 56)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 56).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery57, "Photo Recap: Roaming around Switzerland (Part 57).")}>
                        <img
                            src={Gallery57}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 57)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 57).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery58, "Photo Recap: Roaming around Switzerland (Part 58).")}>
                        <img
                            src={Gallery58}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 58)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 58).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery59, "Photo Recap: Roaming around Switzerland (Part 59).")}>
                        <img
                            src={Gallery59}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 59)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 59).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery60, "Photo Recap: Roaming around Switzerland (Part 60).")}>
                        <img
                            src={Gallery60}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 60)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 60).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery61, "Photo Recap: Roaming around Switzerland (Part 61).")}>
                        <img
                            src={Gallery61}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 61)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 61).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery62, "Photo Recap: Roaming around Switzerland (Part 62).")}>
                        <img
                            src={Gallery62}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 62)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 62).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery63, "Photo Recap: Roaming around Switzerland (Part 63).")}>
                        <img
                            src={Gallery63}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 63)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 63).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery64, "Photo Recap: Roaming around Switzerland (Part 64).")}>
                        <img
                            src={Gallery64}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 64)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 64).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery65, "Photo Recap: Roaming around Switzerland (Part 65).")}>
                        <img
                            src={Gallery65}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 65)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 65).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery66, "Photo Recap: Roaming around Switzerland (Part 66).")}>
                        <img
                            src={Gallery66}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 66)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 66).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery67, "Photo Recap: Roaming around Switzerland (Part 67).")}>
                        <img
                            src={Gallery67}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 67)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 67).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery68, "Photo Recap: Roaming around Switzerland (Part 68).")}>
                        <img
                            src={Gallery68}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 68)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 68).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery69, "Photo Recap: Roaming around Switzerland (Part 69).")}>
                        <img
                            src={Gallery69}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 69)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 69).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery70, "Photo Recap: Roaming around Switzerland (Part 70).")}>
                        <img
                            src={Gallery70}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 70)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 70).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery71, "Photo Recap: Roaming around Switzerland (Part 71).")}>
                        <img
                            src={Gallery71}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 71)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 71).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery72, "Photo Recap: Roaming around Switzerland (Part 72).")}>
                        <img
                            src={Gallery72}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 72)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 72).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery73, "Photo Recap: Roaming around Switzerland (Part 73).")}>
                        <img
                            src={Gallery73}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 73)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 73).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery74, "Photo Recap: Roaming around Switzerland (Part 74).")}>
                        <img
                            src={Gallery74}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 74)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 74).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery75, "Photo Recap: Roaming around Switzerland (Part 75).")}>
                        <img
                            src={Gallery75}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 75)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 75).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery76, "Photo Recap: Roaming around Switzerland (Part 76).")}>
                        <img
                            src={Gallery76}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 76)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 76).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery77, "Photo Recap: Roaming around Switzerland (Part 77).")}>
                        <img
                            src={Gallery77}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 77)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 77).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery78, "Photo Recap: Roaming around Switzerland (Part 78).")}>
                        <img
                            src={Gallery78}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 78)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 78).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery79, "Photo Recap: Roaming around Switzerland (Part 79).")}>
                        <img
                            src={Gallery79}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 79)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 79).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery80, "Photo Recap: Roaming around Switzerland (Part 80).")}>
                        <img
                            src={Gallery80}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 80)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 80).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery81, "Photo Recap: Roaming around Switzerland (Part 81).")}>
                        <img
                            src={Gallery81}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 81)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 81).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery82, "Photo Recap: Roaming around Switzerland (Part 82).")}>
                        <img
                            src={Gallery82}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 82)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 82).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery83, "Photo Recap: Roaming around Switzerland (Part 83).")}>
                        <img
                            src={Gallery83}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 83)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 83).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery84, "Photo Recap: Roaming around Switzerland (Part 84).")}>
                        <img
                            src={Gallery84}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 84)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 84).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery85, "Photo Recap: Roaming around Switzerland (Part 85).")}>
                        <img
                            src={Gallery85}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 85)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 85).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery86, "Photo Recap: Roaming around Switzerland (Part 86).")}>
                        <img
                            src={Gallery86}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 86)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 86).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery87, "Photo Recap: Roaming around Switzerland (Part 87).")}>
                        <img
                            src={Gallery87}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 87)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 87).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery88, "Photo Recap: Roaming around Switzerland (Part 88).")}>
                        <img
                            src={Gallery88}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 88)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 88).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery89, "Photo Recap: Roaming around Switzerland (Part 89).")}>
                        <img
                            src={Gallery89}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 89)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 89).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery90, "Photo Recap: Roaming around Switzerland (Part 90).")}>
                        <img
                            src={Gallery90}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Roaming around Switzerland (Part 90)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Roaming around Switzerland (Part 90).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='flex justify-center items-center px-12 md:mb-8 mb-4 gap-x-8'>
                <Link to="/acl/acl-part7" className='md:text-xl text-lg text-textRed font-bold flex items-center hover:scale-105'>
                    <FaAngleDoubleLeft className='w-3 h-3 text-textRed inline-block mr-1' />
                    PREV 
                </Link>
                <Link to="/acl/acl-part9" className='md:text-xl text-lg text-textRed font-bold flex items-center hover:scale-105'>
                    NEXT 
                    <FaAngleDoubleRight className='w-3 h-3 text-textRed inline-block ml-1' />
                </Link>
            </div>
            <div className='bg-fixed w-full h-96' style={{ backgroundImage: `url(${Gallery31})`, backgroundSize: 'cover',  }}>
            </div>
            <CommentListExample postId={8} seriesId={2}/>
            <ImageModal
                showModal={modalVisible}
                closeModal={closeModal}
                imageUrl={selectedImage}
                imageAlt={selectedAlt}
            />
            <Footer/>
            {arrowTransition((style, item) =>
                item ? (
                <animated.div
                    style={style}
                    className="fixed bottom-5 right-5 cursor-pointer z-10"
                    onClick={scrollToTop}
                >
                    <FaArrowCircleUp
                    size={isMd ? 32 : 24}
                    className="text-[#c0c5ca] hover:scale-110"
                    />
                </animated.div>
                ) : null
            )}
        </div>
    );
};

export default ACLPART8